export default defineNuxtRouteMiddleware((to) => {
	/**
     * We intentionally use 'p' (partner/promo) instead of standard tracking
     * parameters like 'ref' or 'utm_source'. Aggressive adblockers and strict
     * privacy extensions often strip known referral parameters from the URL.
     */

	const refParam = to.query.p as string;

	if (refParam) {
		const refCookie = useCookie('referral_ref', {
			maxAge: 60 * 60 * 24 * 30, // 30 days
			path: '/',
		});

		refCookie.value = refParam;
	}
});
